export const randomItem = (array) =>
  array[Math.floor(Math.random() * array.length)];
